import styles from './InformedConsentView.module.scss';
import { useEffect, useRef, useState } from 'react';
import 'jspdf-autotable';
import Button from '../../components/atoms/Button'
import { DocumentArrowDownIcon } from '@heroicons/react/24/outline';
import { analyticsService } from '../../utils/analyticsService';
import { useLocation, useParams } from 'react-router-dom';
import { trpc } from "../../utils/trpc";
import Modal from "../../components/organisms/Modal";
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';


export const InformedConsentView = ({className}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const {id}: any = useParams();
  const [loadingToggle, setLoadingToggle] = useState(true);
  const [selectedPatientId, setSelectedPatientId] = useState("");
  const {search} = useLocation();
  const queryParams = new URLSearchParams(search);

  const therapistId: any = queryParams.get('therapistId');
  const therapyType: any = queryParams.get('therapyType');

  const userInfo: any = trpc.mainService.therapist.getPatient.useQuery(
    {patientId: selectedPatientId, accountTherapyType: therapyType, therapistId: therapistId},
    {enabled: !!selectedPatientId,}).data;

  const getInformedConsentResponse =
    trpc.mainService.patient.getinformedConsent.useQuery({
      patientId: selectedPatientId,
      accountTherapyType: therapyType,
      additionalTherapistId: therapistId || undefined
    });

  const getCurrentUserInfoResponse =
    trpc.mainService.user.getCurrentUserInfo.useQuery({therapistId: therapistId || undefined});

  const informedConsentResponse: any = getInformedConsentResponse?.data
  const therapist = getCurrentUserInfoResponse?.data?.user

  useEffect(() => {
    analyticsService({
      'event': 'virtualPageview',
      'pageUrl': '/visualizza-il-consenso-informato',
      'pageTitle': 'Informed Consent View'
    });
  }, []);

  useEffect(() => {
    if (id) {
      setSelectedPatientId(id)
    }
    if (userInfo && therapist && informedConsentResponse && therapistId && therapyType) {
      setLoadingToggle(false)
    }
  }, [id, informedConsentResponse, therapist, userInfo]);


  return (
    <div className={`${styles.information} ${className}`}>
      {loadingToggle ?
        <Modal>
          <Spin indicator={<LoadingOutlined style={{fontSize: 32}} spin/>}/>
        </Modal> :
        <>
          <div className={styles.buttonWrapper}>
            <Button leftIcon={<DocumentArrowDownIcon/>}>
              {/*<PDFDownloadLink document={<Doc/>} fileName="consenso-informato.pdf">*/}
              {/*  {*/}
              {/*    ({loading}) =>*/}
              {/*      loading ? 'Loading...' : 'Scarica il PDF'*/}
              {/*  }*/}
              {/*</PDFDownloadLink>*/}
            </Button>
          </div>
          {/*<div ref={contentRef}>*/}
          {/*  {content}*/}
          {/*</div>*/}
        </>
      }
    </div>
  );
};
